<template>
  <div class="text-center py-2 px-3" :style="{
    backgroundColor: '#1d5166',
    color: 'white',
    zIndex: 5,
    fontSize: `${$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? 14 : 16}px`
  }" cols="12">
    <template v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
      {{ $t(`countdown_mobile_text${campaign.isLottery ? '_lottery' : ''}`, {
        countdown: `${Math.floor(timer / 60)}:${(timer % 60).toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false
        })}`
      }) }}
    </template>
    <template v-else>
      {{ $t(`countdown_desktop_text${campaign.isLottery ? '_lottery' : ''}`, {
        countdown: `${Math.floor(timer / 60)}:${(timer % 60).toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false
        })}`
      }) }}
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TM from "@/api/ticket-management";
import { mount } from "@vue/test-utils";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      timer: "order/timer",
      dialog: "dialog/dialog",
      campaign: "event/campaign",
      orderComplete: 'order/orderComplete',
      reserveResponse: "order/reserveResponse"
    })
  },
  methods: {
    ...mapActions({
      showConfirmDialog: "dialog/show",
      resetOrderState: "order/resetOrderState",
      resetCountdown: "order/resetCountdown",
    })
  },
  beforeMount() {
    this.$forceUpdate();
  },
  async updated() {
    if ((!this.timer || this.timer <= 0) && (this.orderComplete === 0 || !this.orderComplete)) {
      this.resetCountdown()
      this.showConfirmDialog({
        error: true,
        title: this.$t('order_cancel'),
        content: this.$t('countdown_timeout_content'),
        redirectPathName: "Order1",
      });
    }
  }
};
</script>
